import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navy px-4 py-12 text-center text-sm text-white/70" data-id="element-71" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-72" data-mp="3gg0za3iktxxn">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-73" data-mp="3gh3ng3oilm9v">Σ MATEMATICA PRONTA</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/60" data-id="element-74" data-mp="32m1cv38q38qq">
          Il programma completo e pronto da stampare per gli insegnanti di matematica italiani, dalla classe 1ª primaria
          al biennio delle superiori.
        </p>
        <nav aria-label="Note legali" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-75" data-mp="37o74x94c1ef">
          <a href="#termini" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-76" data-mp="3ldkgncakmqtt">
            Termini e Condizioni
          </a>
          <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-77" data-mp="29z6vif77cphh">
            Privacy
          </a>
          <a href="#contatti" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-78" data-mp="2eyjoziskwut1">
            Contatti
          </a>
        </nav>
        <p data-id="element-79" data-mp="3lbmw5xyxdiij">© 2026 Matematica Pronta — Tutti i diritti riservati</p>
      </div>
    </footer>;
}